<template>
  <div class="dataCenter">
    <Header @search="onSearch" />
    <Tab />
    <div class="center_container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('首页')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }">{{
          $t('新闻中心')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('资料中心') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h1>{{ $t('资料中心') }}</h1>
      <ul class="center_list" v-if="centerList.length != 0">
        <li
          v-for="(item, index) in centerList"
          :key="index"
          @click="centerDetail(item.contentId)"
        >
          <span>{{ index + 1 }}</span>
          <span :class="{ actives: item.isMark == 1 }">{{ item.title }}</span>
          <span>{{ item.pubTime || item.createTime | dataFilter(true) }}</span>
        </li>
      </ul>
      <ul v-else class="no">
        {{
          $t('暂无数据')
        }}
      </ul>
      <div class="page">
        <p @click="subCurrent">&lt;&lt;</p>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :current-page="current"
          :page-size="pageSize"
          :total="total"
          :clstag="`newscenter|keycount|notice-PC|click-handleCurrentChange`"
        >
        </el-pagination>
        <p @click="addCurrent">&gt;&gt;</p>
        <span
          >{{ $t('共') }} {{ total }} {{ $t('条结果') }} / {{ current }}
          {{ $t('页') }}</span
        >
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './components/headerBanner'
import Tab from './components/headerTab'
import Footer from './components/footer'
import { getNoticeList } from '@/api/news'
export default {
  components: {
    Header,
    Tab,
    Footer
  },
  data() {
    return {
      centerList: [],
      current: 1,
      pageSize: 10,
      total: 0,
      code: ''
    }
  },
  computed: {},
  watch: {},
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    getCenter() {
      getNoticeList({
        cls: this.code,
        pageSize: this.pageSize,
        pageNum: this.current
      }).then(res => {
        this.centerList = res.result && res.result.infos
        this.total = res.result.total
      })
    },
    handleCurrentChange(current) {
      this.current = current
      this.getCenter()
    },
    subCurrent() {
      this.current = 1
      this.getCenter()
    },
    addCurrent() {
      this.current = Math.ceil(this.total / this.pageSize)
      this.getCenter()
    },
    centerDetail(id) {
      this.$router.push({
        path: '/consult',
        query: {
          id: id,
          type: 6
        }
      })
    }
  },
  created() {
    this.code = this.$route.query.tab
    this.getCenter()
    window.scroll(0, 0)
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped lang="scss">
.dataCenter {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  font-size: 14px;
}
.center_container {
  width: 1200px;
  margin: 0 auto;
  h1 {
    font-size: 20px;
    padding-top: 30px;
    font-weight: 600;
    height: 80px;
  }
  h1::after {
    content: '';
    width: 35px;
    height: 10px;
    display: block;
    margin-top: 15px;
    background: #fe8c01;
  }
}
.el-breadcrumb {
  padding-top: 30px;
}
/deep/.el-breadcrumb__inner {
  font-weight: normal;
}
/deep/.el-breadcrumb__inner a:hover,
/deep/.el-breadcrumb__inner.is-link:hover {
  color: #fe8c01;
  cursor: pointer;
}
/deep/.el-breadcrumb__item span {
  color: #fe8c01;
}
.center_list {
  width: 100%;
  margin-top: 30px;
  li {
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    display: flex;
    span {
      &:nth-child(1) {
        width: 44px;
        line-height: 50px;
        padding-left: 20px;
        color: #666;
      }
      &:nth-child(2) {
        width: 1000px;
        line-height: 40px;
        color: #333;
        display: flex;
        align-items: center;
      }
      &:nth-child(3) {
        width: 133px;
        line-height: 40px;
        text-align: center;
        color: #999;
      }
    }
  }
  li:hover {
    cursor: pointer;
  }
}
.actives {
  color: red;
}
.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
  p {
    padding: 0 4px;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid #e9e9e9;
    color: #999;
    border-radius: 3px;
    cursor: pointer;
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #fe8c01;
  color: #fff;
}
.no {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  font-size: 21px;
  color: #999999;
}
</style>
